import { useState, useEffect } from 'react';

export default function PasswordGate({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const correctPassword = process.env.REACT_APP_PASSWORD;
        if (!correctPassword) {
            setIsAuthenticated(true);
            return;
        }
        const userPassword = prompt("Password Required :");
        if (userPassword === correctPassword) {
            setIsAuthenticated(true);
        }
    }, []);

    if (!isAuthenticated) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                margin: 0,
                fontFamily: 'sans-serif'
            }}>
                <h1>Access Denied</h1>
            </div>
        );
    }

    return <>{children}</>;
}
